// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__LUsDE","summary":"CartItem_summary__-cvyO","price":"CartItem_price__9z7H+","amount":"CartItem_amount__WRAl1","actions":"CartItem_actions__Q1HeM"};